import { newId } from '@/utils.js'
import { db, Timestamp } from '@/firebase.js'
import { firestoreAction } from 'vuexfire'

const getDefaultState = () => {
  return {
    data: [],
    ref: ''
  }
}

const state = getDefaultState()

const getters = {
  data(state) {
    return { ...state.data }
  },
  ref(state) {
    return state.ref
  },
  vendors(state) {
    try {
      return Object.assign({}, ...state.data.map(i => ({ [i.id]: i })))
    } catch {
      console.error
      return null
    }
  },
  vendorById(state, getters) {
    return id => {
      try {
        return getters['vendors'][id]
        //return state.data.find(doc => doc.id === id)
      } catch (e) {
        console.error(e)
        return null
      }
    }
  },
  minimumOrderByVendorId(state, getters) {
    return id => {
      try {
        return getters['vendors'][id].minimumOrder
        //return state.data.find(doc => doc.id === id)
      } catch (e) {
        console.error(e)
        return null
      }
    }
  },
  minimumCasesByVendorId(state, getters) {
    return id => {
      try {
        return getters['vendors'][id].minimumCases
      } catch (e) {
        console.error(e)
        return null
      }
    }
  },
  isVendorId(state, getters) {
    return id => {
      return Object.prototype.hasOwnProperty.call(getters['vendors'], id)
    }
  },
  vendorName(state, getters) {
    return id => {
      try {
        return getters['vendors'][id].name
      } catch {
        console.error
        return ''
      }
    }
  },
  terms(state, getters) {
    return id => {
      try {
        return getters['vendors'][id].terms
      } catch {
        console.error
        return ''
      }
    }
  },
  expenseAccount(state, getters) {
    return id => {
      try {
        return getters['vendors'][id].expenseAccount
      } catch {
        console.error
        return ''
      }
    }
  },
  vendorProperty(state, getters) {
    return id => {
      return attributeKey => {
        try {
          return getters['vendors'][id][attributeKey]
        } catch {
          console.error
          return ''
        }
      }
    }
  },
  vendorsActive(state, getters) {
    try {
      return Object.keys(getters['vendors']).filter(id => {
        return getters['isVendorActive'](id)
      })
    } catch {
      return null
    }
  },
  isVendorActive(state, getters) {
    return id => {
      try {
        if (
          !Object.prototype.hasOwnProperty.call(
            getters.vendorById(id),
            'active'
          )
        )
          return true
        return getters.vendorById(id).active ? true : false
      } catch {
        return true
      }
    }
  }
}

const actions = {
  bindStore: firestoreAction(
    ({ bindFirestoreRef, commit, state }, { storeId }) => {
      commit(
        'setRef',
        db
          .collection('stores')
          .doc(storeId)
          .collection('vendors')
      )
      return bindFirestoreRef('data', state.ref.where('status', '==', 'active'))
    }
  ),
  unbindStore: firestoreAction(({ unbindFirestoreRef }) => {
    unbindFirestoreRef('data')
  }),
  create: async function({ getters }, payload) {
    let id = newId()
    let data = {
      ...payload,
      createdAt: Timestamp.now(),
      id: id
    }
    console.log('vendors/create', id, data)
    return getters.ref
      .doc(id)
      .set(data, { merge: true })
      .then(() => id)
      .catch(err => err)
  },
  delete: async function({ dispatch }, id) {
    console.log('vendors/delete', id)
    return dispatch('updateItem', { id, data: { status: 'deleted' } })
  },
  updateItem({ getters, rootGetters }, { id, data }) {
    console.log('vendors/updateItem', id, data)
    return getters.ref.doc(id).update({
      ...data,
      updatedAt: Timestamp.now(),
      updatedBy: rootGetters['user/id']
    })
  },
  resetStoreState({ commit }) {
    commit('resetState', null)
  }
}

const mutations = {
  setRef(state, ref) {
    state.ref = ref
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

const vendors = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions
  // delivering_0(state) {
  //   for (let vendor in state) {
  //     if (state[vendor].orderingDays.includes('sunday')) {
  //       vendorsThisDay.push(vendor)
  //     }
  //   }
  // },
  // filteredOrderingVendorsByDay(state) {
  //   let theseDays = {}
  //   let weekdays = [
  //     'sunday',
  //     'monday',
  //     'tuesday',
  //     'wednesday',
  //     'thursday',
  //     'friday',
  //     'saturday'
  //   ]
  //   weekdays.forEach(day => {
  //     let vendorsThisDay = []
  //     for (const vendor in state.data) {
  //       if (state.data[vendor].orderingDays.includes(day)) {
  //         vendorsThisDay.push(vendor)
  //       }
  //     }
  //     theseDays[day] = vendorsThisDay
  //   })
  //   console.log(
  //     `%c Getters.js %c filteredOrderingVendorsByDay: ${theseDays} %c`,
  //     'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
  //     'background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
  //     'background:transparent'
  //   )
  //   return theseDays
  // }
  // filteredOrderingProductsByVendor(state) {
  //   let theseVendors = {}
  //   for (const vendor in state.vendors) {
  //     let itemsThisVendor = []
  //     for (const product in state.products) {
  //       if (state.products[product].vendor === vendor) {
  //         itemsThisVendor.push(product)
  //       }
  //     }
  //     theseVendors[vendor] = itemsThisVendor
  //   }
  //   console.log(
  //     `%c Getters.js %c filteredOrderingProductsByVendor: ${theseVendors} %c`,
  //     'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
  //     'background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
  //     'background:transparent'
  //   )
  //   return theseVendors
  // },
  // filteredOrderingProductsByDay(state, getters) {
  //   let theseDays = {}
  //   state.weekdays.forEach(day => {
  //     let productsThisDay = []
  //     let vendorsByDay = getters.filteredOrderingVendorsByDay
  //     vendorsByDay[day].forEach(vendor => {
  //       let productsByVendor = getters.filteredOrderingProductsByVendor
  //       productsByVendor[vendor].forEach(product => {
  //         productsThisDay.push(product)
  //       })
  //     })
  //     theseDays[day] = productsThisDay
  //   })
  //   console.log(
  //     `%c Getters.js %c filteredOrderingProductsByDay: ${theseDays} %c`,
  //     'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
  //     'background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
  //     'background:transparent'
  //   )
  //   return theseDays
  // }
  //},
}

export default vendors
